import React from 'react';

interface CustomButtonInterface extends React.ButtonHTMLAttributes<HTMLButtonElement> {}
const Btn = React.forwardRef<HTMLButtonElement, CustomButtonInterface>(
    (props, ref)=> {
        const { ...rest } = props;
        return <button { ...rest } role="button"></button>
    }
)

export default Btn;
